import { render, staticRenderFns } from "./CardPost.vue?vue&type=template&id=b4bc449a&scoped=true"
import script from "./CardPost.vue?vue&type=script&lang=js"
export * from "./CardPost.vue?vue&type=script&lang=js"
import style0 from "./CardPost.vue?vue&type=style&index=0&id=b4bc449a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc449a",
  null
  
)

export default component.exports